import { isUnderMaintenance } from "@v2/shared/config/features.config";
import { UnderMaintenacePage } from "@v2/pages/underMaintenance/underMaintenancePage.ui";

export function UnderMaintenanceGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const isEnabled = isUnderMaintenance();

  return (
    <>
      {isEnabled && <UnderMaintenacePage />}
      {!isEnabled && children}
    </>
  );
}
